import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import instanceStore from './instance';

Vue.use(Vuex);

/**
 * Store spécifique au multiapp qui gère le multilayer
 * diffusio app n'utilise que le store instance.js
 */
const store = new Store({
  strict: process.env.NODE_ENV !== 'production',
  state () {
    return {
      userPosition: null,
      multiApp: {
        visibleLayers: {},
        currentInstanceId: null,
      },
      instances: [],
    };
  },
  getters: {
    currentInstanceId (state) {
      return state.multiApp.currentInstanceId;
    },
    historyState (state, getters) {
      let appState = {};
      let request = {};
      state.instances.forEach(instance => {
        appState[instance] = { ...state[instance].app.state };
        request[instance] = { ...getters[instance + '/requestParams'] };
      });
      return {
        appState,
        request,
      };
    },
  },
  mutations: {
    SET_VISIBLE_LAYERS (state, value) {
      state.multiApp.visibleLayers = value;
    },
    SET_CURRENT_VISIBLE_LAYER (state, { instanceId, value }) {
      state.multiApp.visibleLayers[instanceId] = value;
    },
    ADD_INSTANCE (state, value) {
      state.instances.push(value);

      // Ajouter les layers pour le multiapp
      let newLayerValue = {};
      newLayerValue[value] = false;
      state.multiApp.visibleLayers = { ...state.multiApp.visibleLayers, ...newLayerValue };
    },
    SET_CURRENT_INSTANCE (state, instanceId) {
      state.multiApp.currentInstanceId = instanceId;
    },
    UPDATE_USER_POSITION (state, userPosition) {
      state.userPosition = userPosition;
    },
  },
  actions: {
    updateMod ({ state, commit, dispatch }, name) {
      for (let index in state.instances) {
        const instanceId = state.instances[index];
        if (state.multiApp.currentInstanceId !== instanceId) {
          commit(instanceId + '/UPDATE_MOD', name);
        }
      }

      dispatch(state.multiApp.currentInstanceId + '/updateMod', name);
    },
    updateUserPosition ({ commit }, userPosition) {
      commit('UPDATE_USER_POSITION', userPosition);
    },
    updateFilter ({ state, commit, dispatch }, filter) {
      for (let index in state.instances) {
        const instanceId = state.instances[index];
        if (state.multiApp.currentInstanceId !== instanceId) {
          commit(instanceId + '/UPDATE', filter);
        }
      }
      dispatch(state.multiApp.currentInstanceId + '/updateFilter', filter);
    },
    setCurrentInstance ({ commit }, { instanceId }) {
      commit('SET_CURRENT_INSTANCE', instanceId);
    },
    addInstance ({ commit, dispatch }, { instanceId, app }) {
      this.registerModule(instanceId, instanceStore);
      commit('ADD_INSTANCE', instanceId);
      dispatch(instanceId + '/setInstance', { instanceId, app });
    },
  },
});

export default store;
